/**
 * The `data-tip` attribute of the player card's name, the anchor whose tooltip reads the character's full name
 * (P2.8-T68, ADR-061).
 */
export const NAME_TIP_ANCHOR = "name:0";
